import { IBaseAction } from '@models/actions/IBaseAction';
import { IActionExecutor } from '@organisms/actions/IActionExecutor';
import { FilesService } from '@services/FilesService';

export class DownloadExecutor implements IActionExecutor {
    run = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
    ) => {
        FilesService.downloadFile(`attachment/download/${parentId}/${objId}`);
    };
}
